"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var state_service_1 = require("./state.service");
var country_service_1 = require("./country.service");
var eligibility_service_1 = require("./eligibility-service");
var base_1 = require("@bhtp-client-api/base");
function bhtpStateServiceFactory(http, cacheRepo) {
    return new state_service_1.BhtpStateService(http, cacheRepo);
}
exports.bhtpStateServiceFactory = bhtpStateServiceFactory;
function bhtpCountryServiceFactory(http, cacheRepo) {
    return new country_service_1.BhtpCountryService(http, cacheRepo);
}
exports.bhtpCountryServiceFactory = bhtpCountryServiceFactory;
function bhtpEligibilityServiceFactory(http) {
    return new eligibility_service_1.BhtpEligibilityService(http);
}
exports.bhtpEligibilityServiceFactory = bhtpEligibilityServiceFactory;
var BhtpEligibilityModule = (function () {
    function BhtpEligibilityModule() {
    }
    return BhtpEligibilityModule;
}());
BhtpEligibilityModule = __decorate([
    core_1.NgModule({
        providers: [
            { provide: state_service_1.BhtpStateService, useFactory: bhtpStateServiceFactory, deps: [http_1.Http, 'ICacheRepository'] },
            { provide: country_service_1.BhtpCountryService, useFactory: bhtpCountryServiceFactory, deps: [http_1.Http, 'ICacheRepository'] },
            { provide: eligibility_service_1.BhtpEligibilityService, useFactory: bhtpEligibilityServiceFactory, deps: [http_1.Http] },
            { provide: 'ICacheRepository', useClass: base_1.SessionStorage }
        ],
    })
], BhtpEligibilityModule);
exports.BhtpEligibilityModule = BhtpEligibilityModule;
//# sourceMappingURL=D:/a/1/s/eligibility/src/eligibility-module.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/eligibility-module.js